import { DataBean } from "../DataBean";

export class DayConstantList extends DataBean {



    public async getDayConstantList(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getDayConstantList_Number", [id]);
    }

}
